var _excluded = ["key"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, useMemo } from 'react';
import { PlusMinor } from '@shopify/polaris-icons';
import { classNames } from '../../utilities/css.js';
import styles from './AlphaFilters.scss.js';
import { SearchField } from './components/SearchField/SearchField.js';
import { FilterPill } from './components/FilterPill/FilterPill.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { Text } from '../Text/Text.js';
import { UnstyledButton } from '../UnstyledButton/UnstyledButton.js';
import { Spinner } from '../Spinner/Spinner.js';
import { Box } from '../Box/Box.js';
import { HorizontalStack } from '../HorizontalStack/HorizontalStack.js';
import { Popover } from '../Popover/Popover.js';
import { ActionList } from '../ActionList/ActionList.js';
import { Button } from '../Button/Button.js';
var TRANSITION_DURATION = 'var(--p-motion-duration-150)';
var TRANSITION_MARGIN = '-36px';
var defaultStyle = {
  transition: "opacity ".concat(TRANSITION_DURATION, " var(--p-motion-ease)"),
  opacity: 0
};
var transitionStyles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  },
  unmounted: {
    opacity: 0
  }
};
var defaultFilterStyles = {
  transition: "opacity ".concat(TRANSITION_DURATION, " var(--p-motion-ease), margin ").concat(TRANSITION_DURATION, " var(--p-motion-ease)"),
  opacity: 0,
  marginTop: TRANSITION_MARGIN
};
var transitionFilterStyles = {
  entering: {
    opacity: 1,
    marginTop: 0
  },
  entered: {
    opacity: 1,
    marginTop: 0
  },
  exiting: {
    opacity: 0,
    marginTop: TRANSITION_MARGIN
  },
  exited: {
    opacity: 0,
    marginTop: TRANSITION_MARGIN
  },
  unmounted: {
    opacity: 0,
    marginTop: TRANSITION_MARGIN
  }
};

function AlphaFilters(_ref) {
  var queryValue = _ref.queryValue,
      queryPlaceholder = _ref.queryPlaceholder,
      focused = _ref.focused,
      filters = _ref.filters,
      appliedFilters = _ref.appliedFilters,
      onQueryChange = _ref.onQueryChange,
      onQueryClear = _ref.onQueryClear,
      onQueryBlur = _ref.onQueryBlur,
      onQueryFocus = _ref.onQueryFocus,
      onClearAll = _ref.onClearAll,
      children = _ref.children,
      disabled = _ref.disabled,
      hideFilters = _ref.hideFilters,
      hideQueryField = _ref.hideQueryField,
      disableQueryField = _ref.disableQueryField,
      borderlessQueryField = _ref.borderlessQueryField,
      loading = _ref.loading,
      disableFilters = _ref.disableFilters,
      mountedState = _ref.mountedState,
      onAddFilterClick = _ref.onAddFilterClick;
  var i18n = useI18n();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      popoverActive = _useState2[0],
      setPopoverActive = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      localPinnedFilters = _useState4[0],
      setLocalPinnedFilters = _useState4[1];

  var hasMounted = useRef(false);
  useEffect(function () {
    hasMounted.current = true;
  });

  var togglePopoverActive = function togglePopoverActive() {
    return setPopoverActive(function (popoverActive) {
      return !popoverActive;
    });
  };

  var handleAddFilterClick = function handleAddFilterClick() {
    onAddFilterClick === null || onAddFilterClick === void 0 ? void 0 : onAddFilterClick();
    togglePopoverActive();
  };

  var appliedFilterKeys = appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.map(function (_ref2) {
    var key = _ref2.key;
    return key;
  });
  var pinnedFiltersFromPropsAndAppliedFilters = filters.filter(function (_ref3) {
    var pinned = _ref3.pinned,
        key = _ref3.key;
    return (Boolean(pinned) || (appliedFilterKeys === null || appliedFilterKeys === void 0 ? void 0 : appliedFilterKeys.includes(key))) && // Filters that are pinned in local state display at the end of our list
    !localPinnedFilters.find(function (filterKey) {
      return filterKey === key;
    });
  });
  var pinnedFiltersFromLocalState = localPinnedFilters.map(function (key) {
    return filters.find(function (filter) {
      return filter.key === key;
    });
  }).reduce(function (acc, filter) {
    return filter ? [].concat(_toConsumableArray(acc), [filter]) : acc;
  }, []);
  var pinnedFilters = [].concat(_toConsumableArray(pinnedFiltersFromPropsAndAppliedFilters), _toConsumableArray(pinnedFiltersFromLocalState));

  var onFilterClick = function onFilterClick(_ref4) {
    var key = _ref4.key,
        onAction = _ref4.onAction;
    return function () {
      // PopoverOverlay will cause a rerender of the component and nuke the
      // popoverActive state, so we set this as a microtask
      setTimeout(function () {
        setLocalPinnedFilters(function (currentLocalPinnedFilters) {
          return _toConsumableArray(new Set([].concat(_toConsumableArray(currentLocalPinnedFilters), [key])));
        });
        onAction === null || onAction === void 0 ? void 0 : onAction();
        togglePopoverActive();
      }, 0);
    };
  };

  var filterToActionItem = function filterToActionItem(filter) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      content: filter.label,
      onAction: onFilterClick(filter)
    });
  };

  var unpinnedFilters = filters.filter(function (filter) {
    return !pinnedFilters.some(function (_ref5) {
      var key = _ref5.key;
      return key === filter.key;
    });
  });
  var unsectionedFilters = unpinnedFilters.filter(function (filter) {
    return !filter.section;
  }).map(filterToActionItem);
  var sectionedFilters = unpinnedFilters.filter(function (filter) {
    return filter.section;
  }).reduce(function (acc, filter) {
    var filterActionItem = filterToActionItem(filter);
    var sectionIndex = acc.findIndex(function (section) {
      return section.title === filter.section;
    });

    if (sectionIndex === -1) {
      acc.push({
        title: filter.section,
        items: [filterActionItem]
      });
    } else {
      acc[sectionIndex].items.push(filterActionItem);
    }

    return acc;
  }, []);
  var hasOneOrMorePinnedFilters = pinnedFilters.length >= 1;
  var addFilterActivator = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySm",
    as: "p"
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    className: styles.AddFilter,
    onClick: handleAddFilterClick,
    "aria-label": i18n.translate('Polaris.Filters.addFilter'),
    disabled: disabled || unsectionedFilters.length === 0 && sectionedFilters.length === 0 || disableFilters
  }, /*#__PURE__*/React.createElement("span", null, i18n.translate('Polaris.Filters.addFilter')), /*#__PURE__*/React.createElement(PlusMinor, null))));

  var handleClearAllFilters = function handleClearAllFilters() {
    setLocalPinnedFilters([]);
    onClearAll === null || onClearAll === void 0 ? void 0 : onClearAll();
  };

  var shouldShowAddButton = filters.some(function (filter) {
    return !filter.pinned;
  });
  var additionalContent = useMemo(function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.Spinner
    }, loading ? /*#__PURE__*/React.createElement(Spinner, {
      size: "small"
    }) : null), children);
  }, [loading, children]);
  var queryFieldMarkup = hideQueryField ? null : /*#__PURE__*/React.createElement("div", {
    className: styles.Container
  }, /*#__PURE__*/React.createElement(Box, {
    paddingBlockStart: {
      xs: '3',
      md: '2'
    },
    paddingBlockEnd: {
      xs: '3',
      md: '2'
    },
    paddingInlineStart: "2",
    paddingInlineEnd: {
      xs: '4',
      md: '3'
    }
  }, /*#__PURE__*/React.createElement(HorizontalStack, {
    align: "start",
    blockAlign: "center",
    gap: {
      xs: '4',
      md: '3'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.SearchField,
    style: mountedState ? _objectSpread(_objectSpread({}, defaultStyle), transitionStyles[mountedState]) : undefined
  }, /*#__PURE__*/React.createElement(SearchField, {
    onChange: onQueryChange,
    onFocus: onQueryFocus,
    onBlur: onQueryBlur,
    onClear: onQueryClear,
    value: queryValue,
    placeholder: queryPlaceholder,
    focused: focused,
    disabled: disabled || disableQueryField,
    borderlessQueryField: borderlessQueryField
  })), additionalContent)));
  var mountedStateStyles = mountedState && !hideQueryField ? _objectSpread(_objectSpread({}, defaultFilterStyles), transitionFilterStyles[mountedState]) : undefined;
  var pinnedFiltersMarkup = pinnedFilters.map(function (_ref6) {
    var filterKey = _ref6.key,
        pinnedFilter = _objectWithoutProperties(_ref6, _excluded);

    var appliedFilter = appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.find(function (_ref7) {
      var key = _ref7.key;
      return key === filterKey;
    });

    var handleFilterPillRemove = function handleFilterPillRemove() {
      setLocalPinnedFilters(function (currentLocalPinnedFilters) {
        return currentLocalPinnedFilters.filter(function (key) {
          return key !== filterKey;
        });
      });
      appliedFilter === null || appliedFilter === void 0 ? void 0 : appliedFilter.onRemove(filterKey);
    };

    return /*#__PURE__*/React.createElement(FilterPill, Object.assign({
      key: filterKey
    }, pinnedFilter, {
      initialActive: hasMounted.current && !pinnedFilter.pinned && !appliedFilter,
      label: (appliedFilter === null || appliedFilter === void 0 ? void 0 : appliedFilter.label) || pinnedFilter.label,
      filterKey: filterKey,
      selected: appliedFilterKeys === null || appliedFilterKeys === void 0 ? void 0 : appliedFilterKeys.includes(filterKey),
      onRemove: handleFilterPillRemove,
      disabled: pinnedFilter.disabled || disableFilters
    }));
  });
  var addButton = shouldShowAddButton ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.AddFilterActivator, hasOneOrMorePinnedFilters && styles.AddFilterActivatorMultiple)
  }, /*#__PURE__*/React.createElement(Popover, {
    active: popoverActive && !disabled,
    activator: addFilterActivator,
    onClose: togglePopoverActive
  }, /*#__PURE__*/React.createElement(ActionList, {
    actionRole: "menuitem",
    items: unsectionedFilters,
    sections: sectionedFilters
  }))) : null;
  var clearAllMarkup = appliedFilters !== null && appliedFilters !== void 0 && appliedFilters.length || localPinnedFilters.length ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.ClearAll, hasOneOrMorePinnedFilters && shouldShowAddButton && styles.MultiplePinnedFilterClearAll)
  }, /*#__PURE__*/React.createElement(Button, {
    size: "micro",
    plain: true,
    onClick: handleClearAllFilters,
    removeUnderline: true
  }, i18n.translate('Polaris.Filters.clearFilters'))) : null;
  var filtersMarkup = hideFilters || filters.length === 0 ? null : /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.FiltersWrapper, shouldShowAddButton && hasOneOrMorePinnedFilters && styles.FiltersWrapperWithAddButton),
    "aria-live": "polite",
    style: mountedStateStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.FiltersInner)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.FiltersStickyArea)
  }, pinnedFiltersMarkup, addButton, clearAllMarkup)), hideQueryField ? /*#__PURE__*/React.createElement(Box, {
    paddingInlineEnd: "3",
    paddingBlockStart: "2",
    paddingBlockEnd: "2"
  }, /*#__PURE__*/React.createElement(HorizontalStack, {
    align: "start",
    blockAlign: "center",
    gap: {
      xs: '4',
      md: '3'
    }
  }, additionalContent)) : null);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.Filters, hideQueryField && styles.hideQueryField)
  }, queryFieldMarkup, filtersMarkup);
}

export { AlphaFilters };